/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskEvalsDeleteReview } from "../funcs/riskEvalsDeleteReview.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteRiskEvalReviewRequest,
  DeleteRiskEvalReviewSecurity,
} from "../models/operations/deleteriskevalreview.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type RiskDeleteEvalReviewMutationVariables = {
  request: DeleteRiskEvalReviewRequest;
  security?: DeleteRiskEvalReviewSecurity | undefined;
  options?: RequestOptions;
};

export type RiskDeleteEvalReviewMutationData = void;

export type RiskDeleteEvalReviewMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteRiskEvalReview risk
 *
 * @remarks
 * Remove the current reviewer's verdict for one session (the toggle-off path). A reviewer can only clear their own verdict.
 */
export function useRiskDeleteEvalReviewMutation(
  options?: MutationHookOptions<
    RiskDeleteEvalReviewMutationData,
    RiskDeleteEvalReviewMutationError,
    RiskDeleteEvalReviewMutationVariables
  >,
): UseMutationResult<
  RiskDeleteEvalReviewMutationData,
  RiskDeleteEvalReviewMutationError,
  RiskDeleteEvalReviewMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildRiskDeleteEvalReviewMutation(client, options),
    ...options,
  });
}

export function mutationKeyRiskDeleteEvalReview(): MutationKey {
  return ["@gram/client", "evals", "deleteReview"];
}

export function buildRiskDeleteEvalReviewMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: RiskDeleteEvalReviewMutationVariables,
  ) => Promise<RiskDeleteEvalReviewMutationData>;
} {
  return {
    mutationKey: mutationKeyRiskDeleteEvalReview(),
    mutationFn: function riskDeleteEvalReviewMutationFn({
      request,
      security,
      options,
    }): Promise<RiskDeleteEvalReviewMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(riskEvalsDeleteReview(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
